module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_real-estate-b5ee5980aa97acfbd9c3f6550544b5ab.png";